import React, { useState, useCallback, useContext } from 'react';
import styled from 'styled-components';
import {
  FlexColumn,
  FlexColumnCenter,
  Modal,
  RadioButton as BaseRadioButton,
  TextInput as BaseTextInput
} from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(FlexColumnCenter)`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const RadioButton = styled(BaseRadioButton)`
  margin-bottom: 20px;
`;

const Buttons = styled(FlexColumn)`
  align-items: flex-start;
`;

const TextInput = styled(BaseTextInput)`
  width: 80px;
  margin-left: 25px;
`;

const InvoiceDataModal = ({ onClose, onConfirm, usePortal = false }) => {
  const { t } = useContext(ConfigContext);
  const [invoiceProduceOption, setInvoiceProduceOption] = useState('createNew');
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState('');

  const onOptionSelection = useCallback(async () => {
    setIsLoading(true);

    if (invoiceProduceOption === 'createNew') {
      await onConfirm();
    }
    if (invoiceProduceOption === 'createCustom') {
      await onConfirm(invoiceNumber);
    }

    onClose();
    setIsLoading(false);
  }, [invoiceNumber, invoiceProduceOption, onClose, onConfirm]);

  return (
    <Modal
      onClose={onClose}
      showConfirmButton
      confirmText={t('save')}
      loadingConfirm={isLoading}
      isPaddingContent={false}
      size="small"
      disabledConfirm={invoiceProduceOption === 'createCustom' && !invoiceNumber}
      title={t('editInvoiceIssue')}
      onConfirm={onOptionSelection}
      usePortal={usePortal}
      prompt={false}>
      <Wrapper>
        <Buttons>
          <RadioButton
            id="createNew"
            value={invoiceProduceOption}
            onChange={setInvoiceProduceOption}
            content={t('produceNewInvoice')}
          />

          <RadioButton
            id="createCustom"
            value={invoiceProduceOption}
            onChange={setInvoiceProduceOption}
            content={t('attachToExistingInvoice')}
          />

          {invoiceProduceOption === 'createCustom' && (
            <TextInput type="number" value={invoiceNumber} onChange={setInvoiceNumber} title={t('invoiceId')} min={0} />
          )}
        </Buttons>
      </Wrapper>
    </Modal>
  );
};

export default InvoiceDataModal;
